<template>
	<div>
		<div class="mainQueryBox">
			<div class="queryLeft">
				<div class="queryBox">
					<span class="queryTitle">省、直辖市：</span>
					<span class="queryValue">
						<el-select size="medium" filterable allow-create v-model="provinces" placeholder="请选择">
							<el-option v-for="(item, index) in provincesGrouped" :label="item" :value="item" :key="index"></el-option>
						</el-select>
					</span>
				</div>
				<div class="queryBox">
					<span class="queryTitle">城市：</span>
					<span class="queryValue">
						<el-select  size="medium" @visible-change="visibleChange" filterable allow-create v-model="city" placeholder="请选择">
							<el-option v-for="(item, index) in cityGrouped" :label="item" :value="item" :key="index"></el-option>
						</el-select>
					</span>
				</div>
				<el-button  size="medium" type="primary" @click="loadData">搜索</el-button>
				<el-button  size="medium" @click="reset">重置</el-button>
			</div>
			<div class="queryRight">
				<el-dropdown class="queryBox" @command="handleCommand">
					<el-button  size="medium" type="primary">导入</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="1">导入样本</el-dropdown-item>
						<el-dropdown-item command="2">下载模板</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

				<el-button  size="medium" class="queryBox" type="primary" @click="oepnRoughly">添加</el-button>
				<el-button size="medium" class="queryBox" type="danger" @click="allDelete">删除</el-button>
			</div>
		</div>
		<div class="tableBox">
			<el-table v-loading="loading" border :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="provinces" label="省份" align="center"></el-table-column>
				<el-table-column prop="city" label="城市" align="center"></el-table-column>
				<el-table-column prop="cityCode" label="区号" align="center"></el-table-column>
				<el-table-column prop="area" label="地区" align="center"></el-table-column>
				<el-table-column prop="part" label="局名" align="center"></el-table-column>
				<el-table-column prop="partCode" label="号码前缀" align="center"></el-table-column>
				<el-table-column prop="phoneLen" label="号码长度" align="center"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
				<el-table-column label="操作" align="center" width="180px">
					<template slot-scope="scope">
						<el-link type="primary" :underline="false" @click="editThemRoughly(scope.row)">修改</el-link>
						<el-popconfirm style="margin-left: 10px;" title="确定删除吗？" @confirm="delThemRoughly(scope.row.id)">
							<el-link type="primary" :underline="false" slot="reference">删除</el-link>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<div class="block">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pagination.pageNo"
					:page-sizes="[5, 10, 50, 100, 200, 300, 400]"
					:page-size="pagination.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagination.total"
				></el-pagination>
			</div>
		</div>
		<!-- 添加 -->
		<addThemRoughly ref="addThemRoughly" @saveOk="saveOk"></addThemRoughly>
		<!-- 导入 -->
		<el-upload
			class="upload-demo"
			drag
			:action="action"
			multiple
			:show-file-list="false"
			:on-success="handleSuccess"
			name="multipartFile"
			:accept="fileAccept"
			:with-credentials="true"
			:data="QiniuData"
		>
			<el-button ref="inputUpLoad">点击上传</el-button>
		</el-upload>
		<!-- 导入成功展示 -->
		<el-dialog title="提示" :visible.sync="uploadShow" width="500px" append-to-body :close-on-click-modal="false">
			<div class="importData">
				<div class="numbers">
					<div class="num">
						总数量
						<span style="color: #409eff">{{ importobj.total }}</span>
						条
					</div>
					<div class="num">
						成功数量
						<span style="color: #67c23a">{{ importobj.successNum }}</span>
						条
					</div>
					<div class="num">
						失败数量
						<span style="color: #f56c6c">{{ importobj.fail }}</span>
						条
					</div>
				</div>
				<el-button @click="importshow = !importshow" v-if="importobj.messageErrorList.length > 0">查看详情</el-button>
				<div v-show="importshow" v-if="importobj.messageErrorList.length > 0" style="max-height: 300px; overflow: auto">
					<el-divider></el-divider>
					<p>{{ importobj.messageErrorList }}</p>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="uploadShow = false">取 消</el-button>
				<el-button size="medium" type="primary" @click="uploadShow = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import addThemRoughly from './addThemRoughly/index.vue';
export default {
	components: { addThemRoughly },
	data() {
		return {
			uploadShow: false,
			importshow: false,
			importobj: {
				successNum: 0,
				fail: 0,
				total: 0,
				messageErrorList: []
			},
			action: '',
			QiniuData: {
				Authorization: ''
			},
			fileAccept: '.xls,.xlsx',
			city: '',
			cityGrouped: [],
			provinces: '',
			provincesGrouped: [],
			multipleSelection: [],
			tableData: [],
			source: '',
			surveyId: '',
			pagination: {
				pageNo: 1,
				total: 0,
				pageSize: 10
			},
			loading: false
		};
	},
	created() {
		this.surveyId = this.$route.query.id;
		this.source = this.$route.query.source;
		this.action = this.$config.service.importPhonelib;
		let token = window.localStorage.getItem('token');
		this.QiniuData.Authorization = token ? 'Bearer ' + token : '';
		this.loadData(); //   查询局号列表信息
		this.getPhoneLibProviceGroup(); //  获取省份分组信息
	},
	methods: {
		allDelete() {
			if (this.multipleSelection.length == 0) {
				this.$message.warning('请选择要删除的文件');
				return false;
			}
			let that = this;
			let ids = [];
			let tempIDlist = JSON.parse(JSON.stringify(this.multipleSelection));
			tempIDlist.forEach(item => {
				ids.push(item.id);
			});
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let params = {
						that: this,
						url: `${this.$config.service.deletePhonelib}`,
						method: 'POST',
						data: {
							id: ids.toString()
						},
						cb(res) {
							if (res.code == 0) {
								that.loadData();
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		reset() {
			this.city = '';
			this.provinces = '';
			this.loadData();
		},
		visibleChange(value) {
			console.log(value);
			if (value) {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.getPhoneLibCityGroup}`,
					method: 'POST',
					data: {
						provinces: this.provinces
						// id: id
					},
					cb(res) {
						if (res.code == 0) {
							let arr = res.resultBody;
							let newArr = arr.filter(function(value, index, self) {
								return self.indexOf(value) === index;
							});
							that.cityGrouped = newArr;
						}
					}
				};
				this.$util.request(params);
			}
		},
		saveOk() {
			this.loadData(); //   查询局号列表信息
			this.getPhoneLibProviceGroup(); //  获取省份分组信息
		},
		delThemRoughly(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.deletePhonelib}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						that.loadData();
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		editThemRoughly(value) {
			this.$refs.addThemRoughly.form = JSON.parse(JSON.stringify(value));
			this.$refs.addThemRoughly.editVisible();
		},
		oepnRoughly() {
			this.$refs.addThemRoughly.loadVisible();
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		getPhoneLibProviceGroup() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.getPhoneLibProviceGroup}`,
				method: 'POST',
				data: {
					id: that.surveyId
				},
				cb(res) {
					if (res.code == 0) {
						let arr = res.resultBody;
						let newArr = arr.filter(function(value, index, self) {
							return self.indexOf(value) === index;
						});
						that.provincesGrouped = newArr;
					} else {
						that.provincesGrouped = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		loadData() {
			let that = this;
			this.loading = true
			let params = {
				that: this,
				url: `${this.$config.service.getPhoneLibPageList}`,
				method: 'POST',
				data: {
					id: that.surveyId,
					city: that.city,
					provinces: that.provinces,
					currentPage: that.pagination.pageNo,
					pageSize: that.pagination.pageSize
				},
				cb(res) {
					if (res.code == 0) {
						that.tableData = res.resultBody.records;
						that.pagination.total = res.resultBody.total;
					} else {
						that.tableData = [];
						that.pagination.total = 0;
						that.$message.error(res.message);
					}
				},
				finally() {
					that.loading = false
				}
			};
			this.$util.request(params);
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val;
			this.loadData();
		},
		handleCurrentChange(val) {
			this.pagination.pageNo = val;
			this.loadData();
		},
		handleCommand(command) {
			if (command == 1) {
				this.$refs.inputUpLoad.$el.click();
			} else if (command == 2) {
				this.downloadFile();
			}
		},
		handleSuccess(response, file, fileList) {
			console.log('上传', response, file, fileList);
			if (response.code == 0) {
				this.importobj = response.resultBody;
				this.uploadShow = true;
				this.loadData(); //   查询局号列表信息
				this.getPhoneLibProviceGroup(); //  获取省份分组信息
			} else {
				this.$message.error(response.message);
			}
		},
		// 下载模板
		downloadFile() {
			this.$axios({
				method: 'get',
				url: './template/号段库模板.xlsx',
				responseType: 'blob',
			}).then(response => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				let fname = '号段库模板.xlsx';
				link.href = url;
				link.setAttribute('download', fname);
				document.body.appendChild(link);
				link.click();
				this.dialogImport = false;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.mainQueryBox {
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
	.queryLeft {
		display: flex;
		.queryBox {
			display: flex;
			margin-right: 10px;
			align-items: center;
			.queryTitle {
				font-size: 14px;
			}
			.queryValue {
				margin-left: 10px;
			}
		}
		.queryBox:first-child {
			margin-left: 0px;
		}
	}
	.queryRight {
		display: flex;
		.queryBox {
			margin-left: 10px;
		}
		.queryBox:first-child {
			margin-left: 0px;
		}
	}
}

.tableBox {
	.block {
		text-align: right;
		margin-top: 20px;
	}
}
.upload-demo {
	display: none;
}
</style>
